function isElementMovedUpAndOutOfViewport(el) {
  var rect = el.getBoundingClientRect();
  return (
      rect.bottom <= 0 &&
      rect.top < window.innerHeight
  );
}

function checkVisibility() {
  let ogPaymentElement = document.querySelector(".og-payment");
  let stickyatc = document.querySelector("#cstm-sticky-bar");
  if (ogPaymentElement){
  if (isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
      stickyatc.classList.add("mvisible");
    } else {
        stickyatc.classList.remove("mvisible");
    }
  }
}  
window.addEventListener("scroll", checkVisibility);
window.addEventListener("resize", checkVisibility); // Listen for window resize
checkVisibility();

  function updatePriceNimageSticky()
{
  var getData = document.querySelector('div#cstm-sticky-bar select.matc-variantsSelecter').selectedOptions[0].dataset;
  var image = getData.image;
  var price = getData.price;
  var cprice = getData.cprice;
  
if(document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb'))
document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb').src= image;
  
if(document.querySelector('div#cstm-sticky-bar span.matc-price'))
document.querySelector('div#cstm-sticky-bar span.matc-price').innerHTML= price;
 
if(document.querySelector('div#cstm-sticky-bar span.matc-compare-price'))
document.querySelector('div#cstm-sticky-bar span.matc-compare-price').innerHTML= cprice;
}

function addToCartStickyBar()
{
$.ajax({
type: 'POST',
url: '/cart/add.js',
data: {
quantity: parseInt(document.querySelector('.matc-form input[name="quantity"]').value),
id: parseInt(document.querySelector('select#matc-variantsSelect').value)
},
dataType: 'json', 
success: function (data) { 
  var product = data;
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: this.addToCart
        }
       }));
       document.getElementById("cstm-sticky-bar").classList.remove("mvisible");
} 
});
}

initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});

$(document).on('shopify:section:unload', function(event) {
  initslide();
});

function initslide() {
  $('.M-trustpilot-slider-home').slick({
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '200px',
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    prevArrow:"<button type='button' class='slick-prev Mtp-left'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z'/></svg></button>",
    nextArrow:"<button type='button' class='slick-next Mtp-right'><svg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 320 512'><path d='M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z'/></svg></button>",
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          centerMode: true,
          centerPadding: '100px',
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          centerMode: true,
          arrows: false,
          centerPadding: '50px',
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}